export default {
  "nav.spreadsheet": "Spreadsheet",
  "nav.finds": "Finds",
  "nav.guides": "Guides",
  "nav.review": "Review",
  "nav.shipping": "Shipping",
  "nav.comparisons": "Comparisons",
  "nav.safety": "Safety",
  "nav.blog": "Blog",
  "nav.cta": "Explore Spreadsheet",
  "nav.home": "Home",
  "nav.shoppingGuide": "Shopping Guide",

  "hero.h1": "CSSBuy Spreadsheet",
  "hero.subtitle": "Find the best products and resources from CSSBuy in one place. Explore organized spreadsheets, product finds, seller guides, QC information, shipping details and updated resources to make your shopping easier.",
  "hero.cta.primary": "Explore CSSBuy Spreadsheet",
  "hero.cta.secondary": "View CSSBuy Finds",
  "hero.trust1": "Organized product lists",
  "hero.trust2": "Beginner guides",
  "hero.trust3": "Shipping information",
  "hero.trust4": "QC guides",
  "hero.trust5": "Seller resources",
  "hero.trust6": "Updated content",

  "categories.title": "Find Products by Category",
  "categories.subtitle": "Browse through our curated categories and discover the best finds on CSSBuy.",
  "categories.cta": "Explore All Categories",

  "cat.shoes": "Shoes",
  "cat.hoodies": "Hoodies / Sweaters",
  "cat.tshirts": "T-Shirts",
  "cat.jackets": "Jackets",
  "cat.pants": "Pants / Shorts",
  "cat.headwear": "Headwear",
  "cat.sets": "Sets",
  "cat.underwear": "Underwear / Underpants",
  "cat.jersey": "Jersey",
  "cat.accessories": "Accessories",
  "cat.bags": "Bags",
  "cat.belts": "Belts",
  "cat.perfumes": "Perfumes",
  "cat.other": "Other Stuff",

  "featured.spreadsheet.title": "Updated CSSBuy Spreadsheet",
  "featured.spreadsheet.desc": "Find products, categories and useful information organized in a CSSBuy Spreadsheet that is simple to search and compare.",
  "featured.spreadsheet.cta": "View Full Spreadsheet",

  "featured.review.title": "CSSBuy Review",
  "featured.review.desc": "Want to understand how CSSBuy works? Check our guide on features, advantages, limitations, shipping, storage and important points before buying.",
  "featured.review.cta": "Read CSSBuy Review",

  "featured.shipping.title": "CSSBuy Shipping Cost",
  "featured.shipping.desc": "Shipping costs can vary according to destination, weight, volume, carrier and chosen method. Check our complete guide.",
  "featured.shipping.cta": "View Shipping Cost Guide",

  "featured.coupon.title": "CSSBuy Coupon & Discount Code",
  "featured.coupon.desc": "Check information about coupons, promotions and available discount codes. Always verify validity and conditions.",
  "featured.coupon.cta": "View Offers",

  "featured.warehouse.title": "CSSBuy Warehouse",
  "featured.warehouse.desc": "Understand how storage, QC, orders and shipping preparation work.",
  "featured.warehouse.cta": "View Warehouse Guide",

  "featured.safety.title": "Buy with More Safety",
  "featured.safety.desc": "Verify links, sellers, products, payments and shipping conditions before buying.",
  "featured.safety.cta": "Read Safety Guide",

  "articles.title": "More Buying Guides",
  "articles.subtitle": "Explore our library of in-depth CSSBuy guides covering every step of your buying journey.",
  "articles.readMore": "Read Guide",

  "faq.title": "Frequently Asked Questions",
  "faq.q1": "What is CSSBuy Spreadsheet?",
  "faq.a1": "CSSBuy Spreadsheet is an organized collection of product finds, seller information, and buying resources to help you navigate CSSBuy more efficiently. It includes curated product lists, category filters, and updated information to make your shopping experience smoother.",
  "faq.q2": "How do I use CSSBuy Spreadsheet?",
  "faq.a2": "You can browse the spreadsheet by category, search for specific products, check seller ratings, and compare options. Each entry includes product details, seller information, and direct links to purchase. We recommend verifying all information before buying.",
  "faq.q3": "Is CSSBuy legit?",
  "faq.a3": "CSSBuy is a known buying agent that has been operating for several years. However, as with any online shopping platform, it is important to verify sellers, check QC photos, and understand shipping policies before making purchases. This website provides independent guides to help you shop safely.",
  "faq.q4": "Is CSSBuy safe?",
  "faq.a4": "Safety depends on how you use the platform. Always verify seller reputation, check QC (quality control) photos before shipping, use secure payment methods, and understand the refund policy. Our Safety Guide provides detailed tips for secure shopping.",
  "faq.q5": "How much does CSSBuy shipping cost?",
  "faq.a5": "Shipping costs vary based on destination country, package weight, dimensions, shipping carrier, and method chosen. CSSBuy offers multiple shipping lines with different speed and cost options. Check our Shipping Cost Guide for detailed breakdowns.",
  "faq.q6": "Does CSSBuy offer coupons?",
  "faq.a6": "CSSBuy occasionally offers coupons and promotional codes. Availability and conditions change over time. Always verify current offers directly on the platform and check our Coupon Guide for the latest information.",
  "faq.q7": "How does CSSBuy warehouse work?",
  "faq.a7": "CSSBuy warehouse receives your orders from sellers, stores them, performs quality control (QC) checks, and prepares packages for international shipping. You can request photos, combine multiple items, and choose shipping methods from the warehouse.",
  "faq.q8": "Can beginners use CSSBuy?",
  "faq.a8": "Yes, beginners can use CSSBuy, but there is a learning curve. We recommend starting with our Beginner Guide, understanding how the warehouse and QC process works, and making small test orders before larger purchases.",

  "newsletter.title": "Stay Updated",
  "newsletter.subtitle": "Get the latest CSSBuy Spreadsheet updates, product finds, and buying guides delivered to your inbox.",
  "newsletter.placeholder": "Enter your email address",
  "newsletter.button": "Subscribe",
  "newsletter.privacy": "We respect your privacy. Unsubscribe at any time.",
  "newsletter.success": "Thank you for subscribing!",
  "newsletter.error": "Please enter a valid email address.",

  "cta.main.title": "Ready to find your next product?",
  "cta.main.subtitle": "Explore our CSSBuy Spreadsheet, find products and check our main guides before continuing your journey.",
  "cta.main.primary": "Explore CSSBuy Spreadsheet",
  "cta.main.secondary": "Visit Main Website",

  "footer.spreadsheet": "CSSBuy Spreadsheet",
  "footer.desc": "An independent resource hub for CSSBuy users. Not affiliated with or endorsed by CSSBuy.",
  "footer.links.title": "Quick Links",
  "footer.links.spreadsheet": "Spreadsheet",
  "footer.links.finds": "Finds",
  "footer.links.review": "Review",
  "footer.links.shipping": "Shipping",
  "footer.links.coupon": "Coupon",
  "footer.links.safety": "Safety",
  "footer.links.blog": "Blog",
  "footer.resources.title": "Resources",
  "footer.resources.guides": "Buying Guides",
  "footer.resources.qc": "QC Guide",
  "footer.resources.sellers": "Seller Guide",
  "footer.resources.comparisons": "Comparisons",
  "footer.legal.title": "Legal",
  "footer.legal.about": "About",
  "footer.legal.policy": "Editorial Policy",
  "footer.legal.contact": "Contact",
  "footer.disclaimer": "This website is an independent informational resource and is not affiliated with or endorsed by CSSBuy.",
  "footer.copyright": "© 2026 CSSBuy Spreadsheet. All rights reserved.",

  "lang.en": "English",
  "lang.pt": "Português",
  "lang.de": "Deutsch",

  "dropdown.label": "All Categories",
  "dropdown.placeholder": "Choose a category...",

  "disclaimer": "This website is an independent informational resource and is not affiliated with or endorsed by CSSBuy.",

  "article.published": "Published",
  "article.updated": "Updated",
  "article.readingTime": "min read",
  "article.author": "Editorial Team",
  "article.sources": "Sources",
  "article.cta": "Explore CSSBuy Spreadsheet",
  "article.ctaSecondary": "Visit Main Website",
  "article.related": "Related Articles",
  "article.breadcrumb.home": "Home",
  "article.breadcrumb.blog": "Blog",
  "article.tableOfContents": "Table of Contents",
  "article.share": "Share this article",
  "article.reportError": "Report an Error",
  "article.lastReviewed": "Last Reviewed"
};